import React from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { SignalWifiConnectedNoInternet4Outlined } from "@mui/icons-material";
import logo from "../../assets/media/images/logo.png";
import { colors } from "../../assets/utils/constants";

const NoNetworkError = () => {
    return (
        <>
            <Box
                sx={{
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Grid container justifyContent={"center"}>
                    <Grid item sm={5}>
                        <Box
                            sx={{
                                height: 300,
                                background: `linear-gradient(180deg, ${colors.bgColor3}, ${colors.bgColor2})`,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-around",
                                alignItems: "center",
                                borderRadius: 5,
                                py: 5,
                            }}
                        >
                            <Box>
                                <SignalWifiConnectedNoInternet4Outlined
                                    color="error"
                                    sx={{
                                        fontSize: 70,
                                        fontWeight: "bold",
                                        opacity: 0.8,
                                    }}
                                />
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        textTransform: "uppercase",
                                        fontWeight: "bold",
                                        color: colors.red,
                                        textAlign: "center",
                                    }}
                                >
                                    Opps! network connection error
                                </Typography>
                            </Box>
                            <Box>
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        color: colors.primary,
                                        fontSize: 13,
                                        textAlign: "center",
                                        p: 3,
                                    }}
                                >
                                    Sorry! It seems like your not connected to
                                    the intenet. Please check your network
                                    connection and try again.
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    "& .logo": {
                                        width: 160,
                                        height: 66,
                                    },
                                }}
                            >
                                <Avatar
                                    src={logo}
                                    variant="squire"
                                    alt="logo"
                                    className="logo"
                                    sx={{
                                        p: 1,
                                        bgcolor: colors.primary,
                                        img: {
                                            objectFit: "contain",
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default NoNetworkError;
